import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';

import { BackstageContentSections } from '../../../constants/ContentSections';
import { AppContext } from '../../../lib/Context';
import { withVisibilityLogger } from '../../VisibilityLogger/VisibilityLogger';
import Icon from '../../Icon';

import FeedIcon from '../../../../static/icons/tab-feed-outline.svg';

import './TranscriptBackstage.scss';

const LINK_TEXT = 'View Transcript';

class TranscriptBackstage extends React.Component {
  static propTypes = {
    transcriptUrl: PropTypes.string,
  };

  constructor(props) {
    super(props);
  }

  static contextType = AppContext;

  onTranscriptLinkClick = e => {
    this.context.integration.action.clicked({
      contentSection: BackstageContentSections.TRANSCRIPT,
      destinationUrl: e.currentTarget.pathname,
    });
  };

  render() {
    return (
      <div className='TranscriptBackstage'>
        <Link
          to={this.props.transcriptUrl}
          key={this.props.transcriptUrl}
          onClick={this.onTranscriptLinkClick}
        >
          <Icon className='feed-icon' glyph={FeedIcon} /> {LINK_TEXT}
        </Link>
      </div>
    );
  }
}

export const TranscriptBackstageWithLogger = withVisibilityLogger(
  { contentSection: BackstageContentSections.TRANSCRIPT },
  { useMemo: true },
)(TranscriptBackstage);

export default TranscriptBackstage;
